export default __webpack_public_path__ + "static/media/defaultAvatar.eb017543.svg";